export enum CompanyProfileTabsEnum {
  COMPANY = 'company',
  CEO = 'ceo',
}
